import {
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild,
} from "@angular/core";
import { ChartOptions, ChartType } from "chart.js";
import * as _ from "lodash";
//import {
//    Color,
//    Label,
//    MultiDataSet,
//    PluginServiceGlobalRegistrationAndOptions,
//} from "ng2-charts";
import { SharedDataService } from "../../../../shared/sharedData.service";

@Component({
    selector: "pending-timecards-dept",
    templateUrl: "./pending-timecard-dept.component.html",
    standalone: false
})
export class PendingTimecardDeptComponent implements OnChanges, OnInit {
    constructor(private _sharedDataService: SharedDataService) {}

    @ViewChild("pendingTcCanvas") pendingTcCanvas?: ElementRef;
    @Input() chartData: any = {};
    departments: any = [];
    selectedBusinessUnit: any = {};
    totaltimecards: any;

    //public doughnutChartLabels: Label[] = [
    //    "Submitters",
    //    "Approvers",
    //    "Finance",
    //    "Payroll",
    //];
    //public doughnutChartData: MultiDataSet = [[]];
    //public doughnutChartColors: Color[] = [
    //    {
    //        backgroundColor: ["#7aa7ef", "#4a4f59", "#18af4b", "#5c0b72"],
    //    },
    //];
    public doughnutChartType: ChartType = "doughnut";
    //public chartoptions?: chartoptions = {
    //    responsive: false,
    //    maintainaspectratio: false,
    //    cutoutpercentage: 75,
    //    legend: { display: false },
    //};

    onDataChange() {
        //this.doughnutChartData[0] = [];

        //this.doughnutChartData = [
        //    [
        //        this.chartData.operationTimecard,
        //        this.chartData.talentTimecard,
        //        this.chartData.financeTimecard,
        //        this.chartData.payrollTimecard,
        //    ],
        //];

        this.totaltimecards =
            this.chartData.operationTimecard +
            this.chartData.talentTimecard +
            this.chartData.financeTimecard +
            this.chartData.payrollTimecard;
    }
    //public doughnutChartPlugins: PluginServiceGlobalRegistrationAndOptions[] = [
    //    {},
    //];

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === "chartData") {
                const current = changes["chartData"]["currentValue"];
                this.chartData = current;

                this.departments = _.get(current, "departmentInfo");
                this.onDataChange();
            }
        }
    }

    ngOnInit() {
        this._sharedDataService
            .getSelectedBusinessUnit()
            .subscribe(
                (selectedBu) => (this.selectedBusinessUnit = selectedBu)
            );
    }
}
